import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
const riskMoments = ['Cuando el EMD no se confirma', 'Cuando no existe timeline real', 'Cuando inspección/appraisal se atrasan vs deadline', 'Cuando se "acuerda" algo sin addendum', 'Cuando remueves contingencias sin entender qué acabas de perder', 'Cuando el cash‑to‑close sube y nadie explica por línea', 'Cuando el CD trae errores y nadie lo "own"', 'Cuando HOA docs llegan tarde', 'Cuando te ignoran y tú no escalas'];
export function RiskMapSection() {
  return <section className="py-24 px-4 bg-[#0F1419] text-[#F5F0E8]" data-id="element-252">
      <div className="max-w-5xl mx-auto" data-id="element-253">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-6" data-id="element-254">
          <span className="text-[#D4A843] font-medium tracking-widest uppercase text-sm" data-id="element-255">
            El mecanismo
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold mt-3 mb-6" data-id="element-256">
            El Mapa de Puntos de Riesgo{' '}
            <span className="text-[#D4A843]" data-id="element-257">(9 momentos)</span>
          </h2>
          <p className="text-lg text-[#8B8578] max-w-2xl mx-auto leading-relaxed" data-id="element-258">
            No te voy a llenar de teoría. Te doy un mapa con{' '}
            <span className="text-[#F5F0E8] font-semibold" data-id="element-259">
              9 momentos exactos
            </span>{' '}
            donde los compradores pierden dinero:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mt-12" data-id="element-260">
          {riskMoments.map((moment, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07,
          duration: 0.5
        }} className="bg-[#1A1F2E] p-6 rounded-xl border border-[#D4A843]/10 flex items-start space-x-4" data-id="element-261">
              <div className="w-10 h-10 bg-[#D4A843] rounded-full flex items-center justify-center shrink-0 text-[#0B0E13] font-bold text-sm" data-id="element-262">
                {index + 1}
              </div>
              <p className="text-[#F5F0E8] font-medium leading-snug" data-id="element-263">
                {moment}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 bg-[#0B0E13] border border-[#D4A843]/20 p-8 rounded-2xl" data-id="element-264">
          <div className="flex items-start space-x-4 max-w-3xl mx-auto" data-id="element-265">
            <AlertTriangle className="w-8 h-8 text-[#D4A843] shrink-0 mt-1" data-id="element-266" />
            <div data-id="element-267">
              <p className="text-lg text-[#F5F0E8] font-semibold mb-2" data-id="element-268">
                Cada punto trae:
              </p>
              <ul className="space-y-2 text-[#8B8578]" data-id="element-269">
                <li className="flex items-center" data-id="element-270">
                  <span className="w-1.5 h-1.5 bg-[#D4A843] rounded-full mr-3 shrink-0" data-id="element-271" />
                  <span data-id="element-272">
                    <span className="text-[#D4A843] font-medium" data-id="element-273">
                      Señales tempranas
                    </span>{' '}
                    — para no enterarte tarde
                  </span>
                </li>
                <li className="flex items-center" data-id="element-274">
                  <span className="w-1.5 h-1.5 bg-[#D4A843] rounded-full mr-3 shrink-0" data-id="element-275" />
                  <span data-id="element-276">
                    <span className="text-[#D4A843] font-medium" data-id="element-277">
                      Acción concreta
                    </span>{' '}
                    — qué haces hoy
                  </span>
                </li>
                <li className="flex items-center" data-id="element-278">
                  <span className="w-1.5 h-1.5 bg-[#D4A843] rounded-full mr-3 shrink-0" data-id="element-279" />
                  <span data-id="element-280">
                    <span className="text-[#D4A843] font-medium" data-id="element-281">
                      Script copy/paste
                    </span>{' '}
                    — para el responsable correcto
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}